import React from "react";
import PropTypes from "prop-types";
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";

function maskIban(iban) {
  if (!iban) return "—";
  const s = String(iban).replace(/\s+/g, "");
  if (s.length <= 8) return s;
  return `${s.slice(0, 4)}••••••${s.slice(-4)}`;
}

export default function SepaPreviewTable({ rows }) {
  return (
    <Paper variant="outlined" sx={{ mb: 2 }}>
      <TableContainer sx={{ maxHeight: 420 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nr.</TableCell>
              <TableCell>Debitor</TableCell>
              <TableCell>IBAN</TableCell>
              <TableCell align="right">Betrag</TableCell>
              <TableCell align="center">Mitglieder</TableCell>
              <TableCell>Verwendungszweck</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <Typography variant="body2" color="text.secondary">
                    Keine Einzüge für die aktuelle Auswahl.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((r, idx) => (
                <TableRow key={`${r.contractId}-${idx}`} hover>
                  <TableCell>{idx + 1}</TableCell>
                  <TableCell>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <span>{r.debtorName}</span>
                      {r.hasTerminated && (
                        <Tooltip
                          title={`${r.terminatedCount} gekündigt(e) Mitglied(er) noch zahlungspflichtig`}
                          arrow
                        >
                          <Chip
                            label={`gekündigt`}
                            color="error"
                            size="small"
                            variant="outlined"
                          />
                        </Tooltip>
                      )}
                    </div>
                  </TableCell>
                  <TableCell>{maskIban(r.iban)}</TableCell>
                  <TableCell align="right">
                    {" "}
                    {new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                    }).format(r.amount)}
                  </TableCell>
                  <TableCell align="center">{r.membersCount}</TableCell>
                  <TableCell>{r.remittance}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

SepaPreviewTable.propTypes = {
  rows: PropTypes.array.isRequired,
};
